import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyle } from "@features/Addons/style";
import { useAddAddonModal } from "@features/Addons/hook/useAddAddonModal";
import { AddAddonAddressOption } from "@features/Addons/AddAddonAddressOption";
import { IBroadbandAddon } from "@features/Addons/interface/IAddonDetails";
import { ConfirmationModal } from "@common/ConfirmationModal/ConfirmationModal";

interface IParams {
    serviceId: number;
    addon: IBroadbandAddon;
    isAddAddonModalOpen: boolean;
    onClose(): void;
    getAddonDetails(): void;
}

export const AddAddonModal = (props: IParams) => {
    const {
        serviceId,
        addon: { code, price, description },
        isAddAddonModalOpen,
        onClose,
        getAddonDetails,
    } = props;
    const { t } = useTranslation("addons");
    const { classes } = useStyle({});
    const {
        contactAddresses,
        selectedContactAddress,
        setSelectedContactAddress,
        handleConfirmAddAddon,
        error,
        isLoading,
    } = useAddAddonModal({ onClose, getAddonDetails });

    const hasOneAddress = contactAddresses.length === 1;

    return (
        <ConfirmationModal
            error={error}
            isLoading={isLoading}
            isModalOpen={isAddAddonModalOpen}
            subtitle={t("willBeAdded", { price })}
            title={t("confirmAddon", { description })}
            onClose={onClose}
            onContinue={() => handleConfirmAddAddon(serviceId, code)}
        >
            <div className={classes.addonModalContainer}>
                <Typography color="secondary" variant="small">
                    {t("willBeSentTo", { description })}
                </Typography>
                {contactAddresses.map((address) => (
                    <AddAddonAddressOption
                        address={address}
                        disabledRadio={hasOneAddress}
                        handleChange={!hasOneAddress ? () => setSelectedContactAddress(address) : undefined}
                        key={address.id}
                        selected={!hasOneAddress && selectedContactAddress?.id === address.id}
                    />
                ))}
            </div>
        </ConfirmationModal>
    );
};
